const FEATURE_NAME = 'comment';

export const commentQueryKeyMap = {
  commentList: (params?: object) =>
    [FEATURE_NAME, 'list', params].filter((item) => item !== undefined),
  comment: (id?: string) =>
    [FEATURE_NAME, 'detail', id].filter((item) => item !== undefined),
  commentInputCandidateUsers: (params?: object) =>
    [FEATURE_NAME, 'inputCandidateUsers', params].filter(
      (item) => item !== undefined,
    ),
  commentInputCandidateOrganizations: (params?: object) =>
    [FEATURE_NAME, 'inputCandidateOrganizations', params].filter(
      (item) => item !== undefined,
    ),
};
